<template>
  <div>
    <b-modal
      :id="modalId"
      ref="modalTambahProduk"
      title=""
      size="md"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      body-class="p-0"
      dialog-class="custom-width-modal"
    >
      <div class="modal-tambah-produk bg-white rounded-lg w-[500px] p-[24px]">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center pb-2">
          <div style="width: 24px;" />
          <h4
            class="m-0 font-weight-bolder text-center flex-grow-1"
            style="color: #222222; font-size: 18px;"
          >
            Tambah Produk
          </h4>
          <b-button
            variant="link"
            class="p-0 text-dark"
            @click="handleClose"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#626262"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </b-button>
        </div>

        <!-- Body Form -->
        <validation-observer
          ref="formRules"
          v-slot="{ handleSubmit, invalid }"
        >
          <b-form @submit.prevent="handleSubmit(submitForm)">
            <b-form-group class="mb-2">
              <label class="d-flex align-items-center mb-50">
                <span
                  class="font-weight-semibold"
                  style="color: #333333; font-size: 14px;"
                >
                  Foto Produk<span class="text-danger">*</span>
                </span>
                <svg
                  v-b-tooltip.hover.bottom="{ title: 'Upload foto produk dengan jelas dan pencahayaan yang baik agar hasil video AI lebih optimal.', customClass: 'tooltip-custom-white tooltip-photo' }"
                  class="ml-50"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 13.3333C10.4978 13.3333 13.3333 10.4978 13.3333 7C13.3333 3.50218 10.4978 0.666664 7 0.666664C3.50218 0.666664 0.666664 3.50218 0.666664 7C0.666664 10.4978 3.50218 13.3333 7 13.3333Z"
                    stroke="#3B82F6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 9.33333V7"
                    stroke="#3B82F6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 4.66667H7.00667"
                    stroke="#3B82F6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </label>
              <validation-provider
                #default="{errors}"
                name="Foto Produk"
                rules="required"
              >
                <div
                  :class="['upload-box', !form.imageFile ? 'py-5 text-center px-3' : 'p-0']"
                  :style="[
                    { border: errors.length > 0 && !form.imageFile ? '1px dashed #EA5455' : (isDragging ? '2px dashed #3B82F6' : (!form.imageFile ? '2px dashed #E5E5E5' : '')) },
                    { backgroundColor: isDragging ? '#EFF6FF' : 'transparent' },
                    { borderRadius: '8px', cursor: 'pointer' }
                  ]"
                  @click="triggerFileInput"
                  @dragover.prevent="isDragging = true"
                  @dragleave.prevent="isDragging = false"
                  @drop.prevent="onDrop"
                >
                  <div v-if="!form.imageFile">
                    <div class="mb-50 flex items-center justify-center w-full">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                          stroke="#626262"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17 8L12 3L7 8"
                          stroke="#626262"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12 3V15"
                          stroke="#626262"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <p
                      class="mb-50 font-weight-semibold"
                      style="color: #222222; font-size: 14px;"
                    >
                      Drop files or browse
                    </p>
                    <p
                      class="m-0"
                      style="color: #828282; font-size: 12px;"
                    >
                      Format file: .jpg, .jpeg, .png, max size 5MB
                    </p>
                  </div>
                  <div
                    v-else
                    class="d-flex align-items-center justify-content-start w-100"
                  >
                    <div class="mr-1 position-relative">
                      <b-img
                        :src="fileUrl(form.imageFile)"
                        style="width: 100px; height: 100px; object-fit: cover; border-radius: 8px;"
                      />
                      <div
                        class="position-absolute d-flex align-items-center justify-content-center"
                        style="bottom: 4px; right: 4px; width: 28px; height: 28px; background: rgba(0, 0, 0, 0.5); border-radius: 6px; cursor: pointer; z-index: 2;"
                        @click.stop="previewImage"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.5 12C2.5 12 7 5 12 5C17 5 21.5 12 21.5 12C21.5 12 17 19 12 19C7 19 2.5 12 2.5 12Z"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div class="d-flex flex-column align-items-start">
                      <b-button
                        variant="outline-secondary"
                        size="sm"
                        class="mb-50 d-flex align-items-center bg-white"
                        style="border-radius: 8px; color: #222222; border-color: #E2E8F0;"
                        @click.stop="triggerFileInput"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="mr-50"
                        >
                          <path
                            d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                            stroke="#626262"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17 8L12 3L7 8"
                            stroke="#626262"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12 3V15"
                            stroke="#626262"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Ubah Foto
                      </b-button>
                      <p
                        class="m-0"
                        style="color: #828282; font-size: 12px; text-align: left;"
                      >
                        Format file: .jpg, .jpeg, .png, max size 5MB
                      </p>
                    </div>
                  </div>
                  <b-form-file
                    ref="fileInput"
                    v-model="form.imageFile"
                    accept="image/jpeg, image/png, image/jpg"
                    class="d-none"
                    @change="onFileChange"
                  />
                </div>
                <small
                  v-if="errors[0] && !form.imageFile"
                  class="text-danger mt-50 d-block"
                >Foto Produk wajib diupload!</small>
              </validation-provider>
            </b-form-group>

            <!-- Nama Produk -->
            <b-form-group class="mb-2">
              <label class="d-flex align-items-center mb-50">
                <span
                  class="font-weight-semibold"
                  style="color: #333333; font-size: 14px;"
                >
                  Nama Produk<span class="text-danger">*</span>
                </span>
              </label>
              <validation-provider
                #default="{errors}"
                name="Nama Produk"
                rules="required|max:60"
              >
                <b-form-input
                  v-model="form.name"
                  placeholder="Masukan nama produk"
                  :state="errors.length > 0 ? false : null"
                  maxlength="60"
                  class="custom-input"
                />
                <div class="d-flex justify-content-between mt-50">
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Nama Produk wajib diisi!</small>
                  <small v-else />
                  <small style="color: #828282;">{{ form.name.length }}/60</small>
                </div>
              </validation-provider>
            </b-form-group>

            <!-- Deskripsi Produk -->
            <b-form-group class="mb-2">
              <label class="d-flex align-items-center mb-50">
                <span
                  class="font-weight-semibold"
                  style="color: #333333; font-size: 14px;"
                >
                  Deskripsi Produk<span class="text-danger">*</span>
                </span>
                <svg
                  v-b-tooltip.hover.top="{ title: 'Jelaskan fungsi, keunggulan, dan manfaat utama produk agar AI dapat menghasilkan video promosi yang lebih menarik.', customClass: 'tooltip-custom-white tooltip-desc' }"
                  class="ml-50"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 13.3333C10.4978 13.3333 13.3333 10.4978 13.3333 7C13.3333 3.50218 10.4978 0.666664 7 0.666664C3.50218 0.666664 0.666664 3.50218 0.666664 7C0.666664 10.4978 3.50218 13.3333 7 13.3333Z"
                    stroke="#3B82F6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 9.33333V7"
                    stroke="#3B82F6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 4.66667H7.00667"
                    stroke="#3B82F6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </label>
              <validation-provider
                #default="{errors}"
                name="Deskripsi Produk"
                rules="required|max:5000"
              >
                <b-form-textarea
                  v-model="form.description"
                  placeholder="Berikan deskripsi ke produk baru kamu"
                  rows="3"
                  :state="errors.length > 0 ? false : null"
                  maxlength="5000"
                  class="custom-input"
                />
                <div class="d-flex justify-content-between mt-50">
                  <small
                    v-if="errors[0]"
                    class="text-danger"
                  >Deskripsi produk wajib diisi!</small>
                  <small v-else />
                  <small style="color: #828282;">{{ form.description.length }}/5000</small>
                </div>
              </validation-provider>
            </b-form-group>

            <!-- Kategori Produk -->
            <b-form-group class="mb-2">
              <label class="d-flex align-items-center mb-50">
                <span
                  class="font-weight-semibold"
                  style="color: #333333; font-size: 14px;"
                >
                  Kategori Produk<span class="text-danger">*</span>
                </span>
                <svg
                  v-b-tooltip.hover.top="{ title: 'Kategori produk menentukan rekomendasi style UGC yang tersedia untuk video Anda.', customClass: 'tooltip-custom-white tooltip-category' }"
                  class="ml-50"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 13.3333C10.4978 13.3333 13.3333 10.4978 13.3333 7C13.3333 3.50218 10.4978 0.666664 7 0.666664C3.50218 0.666664 0.666664 3.50218 0.666664 7C0.666664 10.4978 3.50218 13.3333 7 13.3333Z"
                    stroke="#3B82F6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 9.33333V7"
                    stroke="#3B82F6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 4.66667H7.00667"
                    stroke="#3B82F6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </label>
              <validation-provider
                #default="{errors}"
                name="Kategori Produk"
                rules="required"
              >
                <v-select
                  v-model="form.categoryId"
                  label="category_name"
                  :reduce="option => option.id"
                  :options="filteredProductCategory"
                  placeholder="Pilih kategori produkmu"
                  :class="{ 'is-invalid': errors.length > 0 }"
                />
                <small
                  v-if="errors[0]"
                  class="text-danger mt-50 d-block"
                >Kategori Produk wajib dipilih!</small>
              </validation-provider>
            </b-form-group>

            <span>Punya variasi produk? <router-link
              to="/add-produk"
              class="underline text-primary"
            >Tambahkan Sekarang</router-link></span>

            <!-- Buttons -->
            <div class="d-flex justify-content-between mt-2 pt-1">
              <b-button
                class="mr-1 btn-batal"
                @click="handleClose"
              >
                Batal
              </b-button>
              <b-button
                type="submit"
                class="ml-1 btn-simpan"
                :disabled="invalid || isSubmitting"
              >
                <b-spinner
                  v-if="isSubmitting"
                  small
                  class="mr-50"
                />
                Simpan
              </b-button>
            </div>

          </b-form>
        </validation-observer>
      </div>
    </b-modal>

    <!-- Modal Preview Image -->
    <ModalPreviewImage
      modal-id="modal-preview-image"
      :image-url="form.imageFile ? fileUrl(form.imageFile) : ''"
    />
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, max } from '@validations'
import { mapState } from 'vuex'
import vSelect from 'vue-select'
import ModalPreviewImage from './ModalPreviewImage.vue'

export default {
  name: 'ModalTambahProdukBuatKonten',
  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect,
    ModalPreviewImage,
  },
  props: {
    modalId: {
      type: String,
      default: 'modal-tambah-produk',
    },
  },
  data() {
    return {
      isSubmitting: false,
      isDragging: false,
      form: {
        imageFile: null,
        name: '',
        description: '',
        categoryId: null,
      },
    }
  },
  computed: {
    ...mapState('filter', ['productCategory']),
    filteredProductCategory() {
      if (!this.productCategory) return []
      return this.productCategory.filter(item => {
        const label = item.category_name
        return (label === 'Kosmetik - Skin Care (Pelembab/Pembersih Wajah/Serum)' || label === 'Makanan, Minuman, Suplemen & Obat-Obatan' || label === 'Pakaian & Tekstil' || label === 'Aksesoris & Barang Pribadi' || label === 'Aksesoris Otomotif & Kendaraan' || label === 'Bibit Tanaman, Regpack (K) ' || label === 'Elektronik & Gadget' || label === 'Perfume (Dg)' || label === 'Perlengkapan Rumah' || label === 'Produk Bayi & Anak-Anak')
      })
    },
  },
  created() {
    // Attempt to fetch categories if store module exists
    this.fetchCategories()
  },
  methods: {
    handleClose() {
      this.$bvModal.hide(this.modalId)
      this.resetForm()
    },
    previewImage() {
      if (this.form.imageFile) {
        this.$bvModal.show('modal-preview-image')
      }
    },
    resetForm() {
      this.form = {
        imageFile: null,
        name: '',
        description: '',
        categoryId: null,
      }
      this.$nextTick(() => {
        if (this.$refs.formRules) {
          this.$refs.formRules.reset()
        }
      })
    },
    triggerFileInput() {
      if (this.$refs.fileInput) {
        const input = this.$refs.fileInput.$el.querySelector('input[type="file"]')
        if (input) input.click()
      }
    },
    onFileChange(e) {
      const file = e.target.files[0]
      if (file) {
        this.validateFile(file)
      }
    },
    onDrop(e) {
      this.isDragging = false
      const file = e.dataTransfer.files[0]
      if (file) {
        this.form.imageFile = file
        this.validateFile(file)
      }
    },
    validateFile(file) {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg']
      if (!allowedTypes.includes(file.type)) {
        this.$toast_error({ message: 'Format file hanya mendukung .jpg, .jpeg, .png' })
        this.$nextTick(() => {
          this.form.imageFile = null
        })
        return
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$toast_error({ message: 'Ukuran file maksimal 5MB' })
        this.$nextTick(() => {
          this.form.imageFile = null
        })
      }
    },
    fileUrl(file) {
      return file ? URL.createObjectURL(file) : ''
    },
    async fetchCategories() {
      try {
        if (!this.productCategory || this.productCategory.length === 0) {
          await this.$store.dispatch('filter/getUpdateProductCategory')
        }
      } catch (error) {
        console.error(error)
      }
    },
    async submitForm() {
      this.isSubmitting = true
      try {
        const formData = new FormData()
        formData.append('product_name', this.form.name)
        formData.append('description', this.form.description)
        formData.append('category_id', this.form.categoryId)
        if (this.form.imageFile) {
          formData.append('image', this.form.imageFile)
        }
        const response = await this.$http_new.post('/komship/api/v1/products/create-lite', formData)
        const responseData = response.data

        const isSuccess = responseData && (
          responseData.code === 200
          || responseData.code === 201
          || String(responseData.status || '').toLowerCase() === 'success'
          || responseData.success === true
          || responseData.meta?.code === 200
          || responseData.meta?.code === 201
          || String(responseData.meta?.status || '').toLowerCase() === 'success'
        )

        if (isSuccess) {
          this.$toast_success({ message: 'Produk berhasil disimpan' })
          this.handleClose()
          this.$emit('product-saved', responseData.data || responseData)
        } else {
          const errMsg = responseData?.meta?.message || responseData?.message || 'Gagal menyimpan produk'
          this.$toast_error({ message: errMsg })
        }
      } catch (error) {
        console.error(error)
        const errorMessage = error.response?.data?.meta?.message || error.response?.data?.message || error.message || 'Terjadi kesalahan saat menyimpan produk'
        this.$toast_error({ message: errorMessage })
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>

<style scoped>
:deep(.custom-width-modal) {
  max-width: 700px !important;
  width: 700px !important;
}
.modal-tambah-produk ::v-deep .modal-content {
  border-radius: 12px;
  overflow: hidden;
}
.upload-box:hover {
  background-color: #F1F5F9 !important;
}
.btn-batal {
  border-radius: 8px !important;
  flex: 1;
  background-color: #FFFFFF !important;
  border: 1px solid #E2E8F0 !important;
  color: #222222 !important;
  font-weight: 500 !important;
  height: 44px;
}
.btn-batal:hover {
  background-color: #F8FAFC !important;
}

.btn-simpan {
  border-radius: 8px !important;
  flex: 1;
  background-color: #F97316 !important;
  border-color: #F97316 !important;
  color: #FFFFFF !important;
  font-weight: 500 !important;
  height: 44px;
}
.btn-simpan:hover {
  background-color: #EA580C !important;
}
.btn-simpan:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  background-color: #FCA5A5 !important;
  border-color: #FCA5A5 !important;
}

.custom-input {
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  box-shadow: none;
  font-size: 14px;
  color: #222222;
  background-color: #FFFFFF;
}
select.custom-input {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 9L12 15L18 9' stroke='%23626262' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 14px center !important;
  background-size: 16px 16px !important;
  padding-right: 40px !important;
}
.custom-input:focus {
  border-color: #F97316;
  box-shadow: 0 0 0 0.2rem rgba(249, 115, 22, 0.15);
}
.custom-input::placeholder {
  color: #94A3B8;
  font-size: 14px;
}
.custom-input.is-invalid {
  border-color: #EA5455;
  background-image: none;
}
</style>

<style>
.tooltip-custom-white .tooltip-inner {
  background-color: white !important;
  text-align: left !important;
  color: #1e293b !important;
  border: 1px solid #F95E16 !important;
  font-family: inherit !important;
  padding: 6px 12px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  margin-left: 100px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}
.tooltip-desc .tooltip-inner {
  max-width: 300px !important;
  width: 300px !important;
}
.tooltip-photo .tooltip-inner {
  max-width: 290px !important;
  width: 290px !important;
}
.tooltip-category .tooltip-inner {
  max-width: 290px !important;
  width: 290px !important;
}
.tooltip-custom-white.bs-tooltip-top .arrow::before {
  border-top-color: #F95E16 !important;
}
.tooltip-custom-white.bs-tooltip-bottom .arrow::before {
  border-bottom-color: #F95E16 !important;
}
.tooltip-custom-white.bs-tooltip-left .arrow::before {
  border-left-color: #F95E16 !important;
}
.tooltip-custom-white.bs-tooltip-right .arrow::before {
  border-right-color: #F95E16 !important;
}
</style>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

.modal-tambah-produk {
  .v-select {
    .vs__dropdown-menu {
      top: auto !important;
      bottom: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 4px !important;
      border-radius: 8px !important;
      box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.12) !important;
      max-height: 200px !important;
      overflow-y: auto !important;
    }
  }
}
</style>
